import { ctxToAscii } from './wasm';
const H = 50;
const W = 50;
const rnd = (num) => Math.random() * num;
const isInRange = (val, limA, limB) => Math.min(limA, limB) <= val && val <= Math.max(limA, limB);
const findThreshold = (t, a, b) => {
    if (isInRange(t, a, b)) {
        return Math.abs(t - a) / Math.abs(a - b);
    }
    return undefined;
};
const calculateWeights = (width, height, circles) => Array.from({ length: height + 1 }, (_v1, y) => Array.from({ length: width + 1 }, (_v2, x) => calculateWeight(x, y, circles)));
const calculateWeight = (cx, cy, circles) => circles.reduce((sum, { x, y, r }) => sum + (r * r) / ((cx - x) ** 2 + (cy - y) ** 2), 0);
const randomCircle = (maxX, maxY, minR, maxR) => ({
    x: rnd(maxX),
    y: rnd(maxY),
    r: rnd(maxR - minR) + minR,
    vx: rnd(0.4) - 0.2,
    vy: rnd(0.4) - 0.2,
});
const updateCircles = (circles, W, H) => circles.map(({ x, y, r, vx, vy }) => {
    x = x + vx;
    if (x < 0 || x > W) {
        vx = -vx;
    }
    y = y + vy;
    if (y < 0 || y > H) {
        vy = -vy;
    }
    return { x, y, r, vx, vy };
});
const calculateLines = (ws, t = 1) => {
    const lines = [];
    ws.forEach((row, y) => row.forEach((wA, x) => {
        var _a, _b;
        const points = [];
        const wB = ws[y][x + 1];
        const wC = (_a = ws[y + 1]) === null || _a === void 0 ? void 0 : _a[x + 1];
        const wD = (_b = ws[y + 1]) === null || _b === void 0 ? void 0 : _b[x];
        const p1 = findThreshold(t, wA, wB);
        const p2 = findThreshold(t, wA, wD);
        const p3 = findThreshold(t, wD, wC);
        const p4 = findThreshold(t, wB, wC);
        if (p1 !== undefined)
            points.push([x + p1, y]);
        if (p2 !== undefined)
            points.push([x, y + p2]);
        if (p3 !== undefined)
            points.push([x + p3, y + 1]);
        if (p4 !== undefined)
            points.push([x + 1, y + p4]);
        if (points.length === 2) {
            lines.push(points);
        }
    }));
    return lines;
};
function drawLines(lines, ctx) {
    const cellH = ctx.canvas.height / H;
    const cellW = ctx.canvas.width / W;
    lines.forEach(([[x1, y1], [x2, y2]]) => {
        ctx.beginPath();
        ctx.moveTo(x1 * cellW, y1 * cellH);
        ctx.lineTo(x2 * cellW, y2 * cellH);
        ctx.stroke();
    });
}
let blobReqId;
export const startBlobs = ($ascii, width = 300, height = 300) => {
    const can = document.createElement('canvas');
    can.width = width;
    can.height = height;
    const ctx = can.getContext('2d');
    const loop = (circles) => {
        const weights = calculateWeights(W, H, circles);
        ctx.clearRect(0, 0, width, height);
        const lines1 = calculateLines(weights);
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, width, height);
        ctx.lineWidth = 2;
        drawLines(lines1, ctx);
        $ascii.set(ctxToAscii(ctx));
        blobReqId = requestAnimationFrame(() => loop(updateCircles(circles, W, H)));
    };
    const circles = Array.from({ length: 10 }, () => randomCircle(W, H, 1, 7));
    loop(circles);
};
export const stopBlobs = () => {
    cancelAnimationFrame(blobReqId);
};
